import { render } from "./CompanyProfileJobsList.vue?vue&type=template&id=3633dd7d&scoped=true"
import script from "./CompanyProfileJobsList.vue?vue&type=script&lang=js"
export * from "./CompanyProfileJobsList.vue?vue&type=script&lang=js"

import "./CompanyProfileJobsList.vue?vue&type=style&index=0&id=3633dd7d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3633dd7d"]])

export default __exports__